module.exports = __webpack_public_path__ + "static/media/icons8-home.53a85314.svg";